import { useListingType } from 'apiProviders'
import { useAuth, useUserData } from 'auth'
import axios from 'axios'
import { useListingContext } from 'listings/listingProvider'

export const apiUrl = import.meta.env.VITE_APP_API_URL

export const API = axios.create({
    baseURL: apiUrl,
    withCredentials: true,
})

export const useApi = () => {
    const { user } = useUserData()
    const { getToken } = useAuth()

    const token = getToken()

    const axiosInstance = axios.create({
        baseURL: apiUrl + (user ? `/${user.orgId}` : ''),
        //withCredentials: true,
        headers: {
            Authorization: `Bearer ${token}`,
        },
    })

    axiosInstance.interceptors.request.use(async config => {
        const token = await getToken()
        //console.log('got token', token)
        config.headers.Authorization = `Bearer ${token}`
        return config
    })

    return axiosInstance
}

export const useListingApi = () => {
    const { user } = useUserData()
    const { listing } = useListingContext()
    const listingType = useListingType()
    const { getToken } = useAuth()

    const axiosInstance = axios.create({
        baseURL: apiUrl + (user ? `/${user.orgId}/listing/${listingType}/${listing.listingId}` : ''),
    })

    axiosInstance.interceptors.request.use(async config => {
        const token = await getToken()
        config.headers.Authorization = `Bearer ${token}`
        return config
    })
    /*
    useEffect(() => {
        axiosInstance.interceptors.request.use((config) => {
            const token = localStorage.getItem('access_token')
            config.headers.Authorization = `Bearer ${token}`
            return config
        }
        )
    }, [ token ])*/

    return axiosInstance
}
